import { useCallback } from 'react';
import { useResource } from 'hooks/useResource';
import salesforceEntitiesService from 'services/salesforceEntitiesService';

const useEntity = (entityId) => {
	const fetchFn = useCallback(async () => {
		if (!entityId) return null;
		const response = await salesforceEntitiesService.getEntity(entityId);
		return response;
	}, [entityId]);

	const { data, loading, error, refetch } = useResource({
		fetchFn,
	});

	return {
		entity: data || null,
		loading,
		error,
		refetch,
	};
};

export default useEntity;
